import React, { useContext, useEffect, useMemo, useState } from "react"
import classNames from "classnames"
import { useLandscapeDisplayInfo } from "@hg/layouts"

import { GlobalContext } from "../../context"

import lightPng from "../../assets/img/record/light.png"
import lightWebP from "../../assets/img/record/light.webp"
import personPng from "../../assets/img/record/person.png"
import personWebP from "../../assets/img/record/person.webp"
import treePng from "../../assets/img/record/tree.png"
import treeWebP from "../../assets/img/record/tree.webp"
import styles from "./index.module.less"

const SubpageBg: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const {
        state: { fontSize },
    } = useContext(GlobalContext)
    const { height } = useLandscapeDisplayInfo()
    const scale = useMemo(() => {
        return height / ((1080 / 16) * fontSize)
    }, [height, fontSize])

    const [ignite, setIgnite] = useState(false)
    // const [isPresent, safeToRemove] = usePresence()
    // useEffect(() => {
    //     if (isPresent) {
    //         const timer = setTimeout(() => setIgnite(true), 1000)
    //         return () => clearTimeout(timer)
    //     } else {
    //         setIgnite(false)
    //         safeToRemove()
    //     }
    // }, [isPresent])
    useEffect(() => {
        const timer = setTimeout(() => {
            setIgnite(true)
        }, 1000)
        return () => clearTimeout(timer)
    }, [])
    return (
        <div className={classNames(styles.subpageBg, className)} style={style}>
            <div className={styles.bg}>
                {Array.from({ length: 2 }).map((_, index) => (
                    <div className={styles.tree} key={index}>
                        <picture>
                            <source srcSet={treeWebP} type="image/webp" />
                            <img src={treePng} alt="tree" />
                        </picture>
                    </div>
                ))}
            </div>

            <div className={styles.cloud} />
            <div className={styles.tree}>
                <picture>
                    <source srcSet={treeWebP} type="image/webp" />
                    <img src={treePng} alt="tree" />
                </picture>
            </div>
            <div
                className={classNames(styles.smoke, ignite && styles.ignite)}
                style={{ transform: `scale(${scale})` }}
            >
                <div className={styles.person}>
                    <picture>
                        <source srcSet={personWebP} type="image/webp" />
                        <img src={personPng} alt="person" />
                    </picture>
                </div>
                <div className={styles.light}>
                    <picture>
                        <source srcSet={lightWebP} type="image/webp" />
                        <img src={lightPng} alt="light" />
                    </picture>
                </div>

                <div className={styles.ray} />
            </div>
        </div>
    )
}

export default SubpageBg
